import {Component, ContentChild, Inject, Input, LOCALE_ID, OnChanges, SimpleChanges, TemplateRef} from '@angular/core';
import {UntypedFormBuilder, UntypedFormControl, UntypedFormGroup} from '@angular/forms';
import {ContentDirective} from '../../../../../shared/directives/content.directive';
import {CustomDateModel} from '../../../../../modules/common/custom-date/entity/custom-date.model';
import {BehaviorSubject} from 'rxjs';
import {SelectFilterElement} from '../../../select-filter/select-filter.model';
import {MomentAdapter, MomentUtils} from '../../../../../shared/utils/moment.utils';
import {StringUtils} from '../../../../../shared/utils/string.utils';
import {SelectElement} from '../../../select/select.model';
import {Moment} from 'moment';
import {CustomDatePayload} from '../../../../../modules/common/custom-date/entity/payload/custom-date.payload';

@Component({
  selector: 'app-custom-date-input',
  templateUrl: './custom-date-input.component.html'
})
export class CustomDateInputComponent implements OnChanges {

  readonly now = MomentAdapter.current().get();

  @ContentChild(ContentDirective, { static: true, read: TemplateRef }) template: TemplateRef<any>;

  @Input() parentFormGroup: UntypedFormGroup;
  @Input() initialTypeValue: string;
  @Input() initialDate: Moment;

  types: SelectElement[] = [
      {value : 'CUSTOM_DATE_TYPE_DATE', label : 'Date'}
    , {value : 'CUSTOM_DATE_TYPE_MONTH_YEAR', label : 'Mois'}
    , {value : 'CUSTOM_DATE_TYPE_YEAR', label : 'Année'}
  ];
  years: BehaviorSubject<SelectFilterElement<number, number>[]> = new BehaviorSubject<SelectFilterElement<number, number>[]>([]);
  months: BehaviorSubject<SelectFilterElement<number, string>[]> = new BehaviorSubject<SelectFilterElement<number, string>[]>([]);


  constructor(private formBuilder: UntypedFormBuilder, @Inject(LOCALE_ID) locale) {

    // Years construction
    const values: number[] = [];
    for (let i = MomentUtils.currentYear() + 1; i > MomentUtils.currentYear() - 100; i--) {
      values.push(i);
    }
    this.years.next(values.map(value => new SelectFilterElement(value, value, value)));

    // Month elements
    const monthsElements: SelectFilterElement<number, string>[] = [];
    const months = MomentUtils.months(locale);
    for (let i = 1; i <= months.length; i++) {
      monthsElements.push({id : i, value : i, element : StringUtils.capitalize(months[i - 1])});
    }
    this.months.next(monthsElements);
  }

  get monthControl(): UntypedFormControl {
    return this.parentFormGroup.controls.month as UntypedFormControl;
  }

  get yearControl(): UntypedFormControl {
    return this.parentFormGroup.controls.year as UntypedFormControl;
  }

  get dateControl(): UntypedFormControl {
    return this.parentFormGroup.controls.date as UntypedFormControl;
  }

  get typeControl(): UntypedFormControl {
    return this.parentFormGroup.controls.typeValue as UntypedFormControl;
  }

  entityLoaded(customDate: CustomDateModel) {
    this.dateControl.setValue(customDate?.date, {emitEvent: false});
    this.typeControl.setValue(customDate?.type?.value);
  }

  buildPayload(): CustomDatePayload {
    if (this.typeControl.value) {
      return Object.assign(new CustomDatePayload(), this.parentFormGroup.value);
    } else {
      return undefined;
    }
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['parentFormGroup']) {
      this.parentFormGroup.addControl('typeValue', new UntypedFormControl(this.initialTypeValue));
      this.parentFormGroup.addControl('date', new UntypedFormControl(this.initialDate));
      this.parentFormGroup.addControl('month', new UntypedFormControl(undefined));
      this.parentFormGroup.addControl('year', new UntypedFormControl(undefined));


      this.monthControl.valueChanges.subscribe(() => this.updateDate(this.now, true));
      this.yearControl.valueChanges.subscribe(() => this.updateDate(this.now, false));
      this.typeControl.valueChanges.subscribe((value) => {
        this.updateSelectsValue(value);
      });

      console.log(['this.parentFormGroup.value', this.parentFormGroup.value]);
      if (this.typeControl.value) {
        this.updateSelectsValue(this.typeControl.value);
      } else {
        this.typeControl.setValue('CUSTOM_DATE_TYPE_YEAR');
      }
    }
  }

  updateSelectsValue(typeValue: string) {
   let providedDate = this.dateControl.value ? this.dateControl.value : this.now;
   if (typeValue) {
      if (typeValue === 'CUSTOM_DATE_TYPE_MONTH_YEAR') {
        providedDate = providedDate.set('date', 1);
      } else if (typeValue === 'CUSTOM_DATE_TYPE_YEAR') {
        providedDate = providedDate.set('month', 0)
            .set('date', 1);
      } else {
        providedDate = providedDate;
      }
      const month = providedDate.month() + 1;
      const year = providedDate.year();
      this.monthControl.setValue(month, {emitEvent: false});
      this.yearControl.setValue(year, {emitEvent: false});
      this.dateControl.setValue(providedDate);
    } else {
      this.dateControl.setValue(undefined);
      this.yearControl.setValue(undefined);
      this.yearControl.setValue(undefined);
    }
  }

  dateSelected() {
    return this.typeControl.value === 'CUSTOM_DATE_TYPE_DATE';
  }

  monthSelected() {
    return this.typeControl.value === 'CUSTOM_DATE_TYPE_MONTH_YEAR';
  }

  yearSelected() {
    return this.typeControl.value === 'CUSTOM_DATE_TYPE_YEAR';
  }

  onDeleteCustomDate() {
    this.typeControl.setValue(null);
  }

  private updateDate(date: Moment, month: boolean) {
    date.set('date', 1);
    date.set('month', month === true ? this.monthControl.value - 1 : 0);
    date.set('year', this.yearControl.value);
    this.dateControl.setValue(date);
  }
}
